import React, { Component } from 'react';
import Form from '../../components/react-validation/components/form';
import Submit from '../../components/react-validation/components/submit';
import Input from '../../components/react-validation/components/input';
import Textarea from '../../components/react-validation/components/text-area';
import Modal from '../../components/modal';
import * as Vali from '../../helper/validator-helper';
import PropTypes from 'prop-types';
import * as RegionMarketActionType from '../constants';
import Translate from '../../components/translate';

export class AddEditRegion extends Component {

  static propTypes = {
    isOpenFormAddEdit: PropTypes.bool,
    errorMsg: PropTypes.array,
    isCreate: PropTypes.bool,
    onSubmit: PropTypes.func,
    title: PropTypes.string,
    item: PropTypes.object,
    onCloseModal: PropTypes.func
  }
  constructor(props) {
    super(props);

  }

  componentWillReceiveProps(nextProps) {
    if (this.form) {
      this.form.resetForm(this.refs);
      if (nextProps.errorMsg.length) {
        this.form.showError(this.refs['name'], nextProps.errorMsg[0].error);
      }
    }
  }

  mapParam() {

    let param = this.form.getValues();

    return param;
  }

  onSubmit(e) {

    if (this.props.isCreate) {
      this.props.onSubmit(e,
        this.mapParam(),
        RegionMarketActionType.CREATE_REGION_ASYNC);
    } else {
      this.props.onSubmit(e,
        this.mapParam(),
        RegionMarketActionType.UPDATE_REGION_ASYNC);
    }

    e.preventDefault();
  }

  render() {
    const title = <span>{this.props.title} <Translate translateKey='region' capitalize /></span>;

    return <Modal id='frmEditRegion' show={this.props.isOpenFormAddEdit} title={title} closeButton={true} onHide={this.props.onCloseModal}>
      {/*<div className='modal-header'>
        <button type='button' className='close' data-dismiss='modal'>&times;</button>
        <h4 className='modal-title'>{this.props.title}</h4>
      </div>*/}
      <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit.bind(this)}>
        <Input type='hidden' name='id' ref='id' value={this.props.item.id} />
        <div className='form-group'>
          <label><Translate translateKey='region' capitalize /> name <span className='text-danger'>*</span></label>
          <Input type='text'
            autoFocus
            name='name'
            ref='name'
            value={this.props.item.name}
            placeholder='Region name'
            // placeholder={<Translate translateKey='region' capitalize />}
            className='form-control'
            max='40'
            maxLength='40'
            validations={[Vali.required, Vali.maxlength]} />
        </div >
        <div className='form-group'>
          <label>Description </label>
          <Textarea
            name='description'
            ref='description'
            value={this.props.item.description}
            placeholder='Description'
            className='form-control'
            max='200'
            maxLength='200'
            validations={[Vali.maxlength]} />
        </div >
        <div className='modal-footer'>
          <Submit className='btn btn-primary btn-siteone'>Done</Submit>
        </div>
      </Form>
    </Modal>;
  }
}




// WEBPACK FOOTER //
// ./src/Region-Market/Containers/add-edit-region.js